import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-container">

      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-overlay">
          <h1>About SaveBite</h1>
          <p>
            We are on a mission to reduce food waste and ensure every plate
            counts. Together, we can build a hunger-free world.
          </p>
        </div>
      </div>

      {/* Who We Are */}
      <section className="about-section">
        <h2>Who We Are</h2>
        <p>
          SaveBite is a smart platform that connects food donors with NGOs
          and people in need. We aim to reduce food waste and make surplus
          food accessible to those who need it most.
        </p>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="card">
          <h3>🌍 Our Mission</h3>
          <p>
            To reduce food waste and fight hunger by creating a reliable
            and easy-to-use food donation network.
          </p>
        </div>

        <div className="card">
          <h3>👁 Our Vision</h3>
          <p>
            A world where no food is wasted and no person sleeps hungry.
          </p>
        </div>
      </section>

      {/* Call to Action */}
      <section className="about-cta">
        <h2>Be a Part of the Change</h2>
        <button className="primary-btn">Join SaveBite</button>
      </section>

    </div>
  );
}

export default About;
